const defaults = {
  createdAt: null,
  createdByUserId: null,
  name: null,
  ordering: null,
  portalId: null
};
export function createActivityType(json) {
  var _json$createdAt, _json$createdByUserId, _json$name, _json$ordering, _json$portalId;
  if (!json) return Object.assign({}, defaults);
  return {
    createdAt: (_json$createdAt = json.createdAt) !== null && _json$createdAt !== void 0 ? _json$createdAt : null,
    createdByUserId: (_json$createdByUserId = json.createdByUserId) !== null && _json$createdByUserId !== void 0 ? _json$createdByUserId : null,
    name: (_json$name = json.name) !== null && _json$name !== void 0 ? _json$name : null,
    ordering: (_json$ordering = json.ordering) !== null && _json$ordering !== void 0 ? _json$ordering : null,
    portalId: (_json$portalId = json.portalId) !== null && _json$portalId !== void 0 ? _json$portalId : null
  };
}